/**
 * Google Translate compatibility patch for React 18/19
 *
 * When browser translation (Google Translate, built-in Chrome/Edge/Safari,
 * browser extensions) is active on a page, it replaces text nodes with
 * <font>...</font> wrappers. When React later tries to remove or move those
 * original text nodes during reconciliation, it throws:
 *
 *   NotFoundError: Failed to execute 'removeChild' on 'Node':
 *   The node to be removed is not a child of this node.
 *
 * This shim detects that exact case — when the node React is trying to
 * remove/insert is no longer a direct child (because translation wrapped
 * it) — and either removes it from wherever it actually lives OR silently
 * no-ops. Translation continues to work; React doesn't crash.
 *
 * Reference: https://github.com/facebook/react/issues/11538
 */

if (typeof Node === 'function' && Node.prototype) {
  const originalRemoveChild = Node.prototype.removeChild;
  Node.prototype.removeChild = function (child) {
    if (child.parentNode !== this) {
      if (child.parentNode) {
        // Node got re-parented by a translation wrapper — remove it from its
        // actual parent so React's intent (deletion) is honored.
        return child.parentNode.removeChild(child);
      }
      if (typeof console !== 'undefined' && console.warn) {
        console.warn('[gtranslate-patch] Suppressed removeChild on detached node', child);
      }
      return child;
    }
    return originalRemoveChild.apply(this, arguments);
  };

  const originalInsertBefore = Node.prototype.insertBefore;
  Node.prototype.insertBefore = function (newNode, referenceNode) {
    if (referenceNode && referenceNode.parentNode !== this) {
      if (typeof console !== 'undefined' && console.warn) {
        console.warn('[gtranslate-patch] Suppressed insertBefore with foreign referenceNode', referenceNode);
      }
      // Fall back to appendChild so React's insert still happens.
      return this.appendChild(newNode);
    }
    return originalInsertBefore.apply(this, arguments);
  };
}
